module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Compilation-22747ff683c36fdb11108ddb24912178.svg";